<template>
    <div class="product">
        <!-- 产品顶部 banner 部分（同步方案页布局） -->
        <div class="banner">
            <!-- 核心容器：限制宽度120rem并居中 -->
            <div class="banner-container" :style="{ backgroundImage: `url(${product.topPhotos})` }">
                <!-- 左侧标题区域 -->
                <div class="title-wrap">
                    <div class="title-row">
                        <h1 class="red-title">{{ product.redTitle }}</h1>
                        <h1 v-if="product.redTitle" style="color: #cccccc;font-size: 40px;font-weight: 100">|</h1>
                        <h1 class="main-title">{{ product.chName }}</h1>
                    </div>
                    <h2 class="sub-title">{{ product.smallTitle }}</h2>
                    <p class="synopsis">{{ product.enName }}</p>
                </div>

<!--                &lt;!&ndash; 右侧图片 &ndash;&gt;-->
<!--                <img-->
<!--                        :src="product.topPhotos"-->
<!--                        class="banner-image"-->
<!--                        alt=""-->
<!--                />-->
            </div>
        </div>
        <!-- 动态展示组件部分（同步方案页zhWordDetailList渲染逻辑） -->
        <div class="wrap">
            <component
                    style="margin-top: 150px;"
                    v-for="(item, index) in product.zhWordDetailList"
                    :key="index"
                    :is="getComponentName(item.detailType)"
                    :sourceData="item.detail"
                    :title="item.title"
                    :backUrl="item.backImg"
            />
        </div>
    </div>
</template>

<script>
import newService from "@/api/newService";
// 复用方案页相同的详情组件
import sanjiaoxinghexing from "@/components/mian/detailViews/sanjiaoxinghexing.vue";
import fuwenben from "@/components/mian/detailViews/fuwenben.vue";
import hengtu from "@/components/mian/detailViews/hengtu.vue";
import sanhengtufuwenben from "@/components/mian/detailViews/sanhengtufuwenben.vue";
import yeqianfuwenben from "@/components/mian/detailViews/yeqianfuwenben.vue";
import zuoyiyouer from "@/components/mian/detailViews/zuoyiyouer.vue";
import {ArrowRight} from "@element-plus/icons-vue";

export default {
    name: "productFone",
    data() {
        return {
            bannerimg:"product4/produc9.png",
            // 严格对齐方案页数据结构，仅保留指定字段
            product: {
                zhWordDetailList: [],
                redTitle: "",
                title: "",
                smallTitle: "",
                synopsis: "",
                topPhotos: ""
            }
        };
    },
    mounted() {
        // 页面加载时获取产品数据
        this.getOneProduct();
    },
    watch: {
      '$store.state.productId': {
        handler() {
          this.getOneProduct()
        },
        immediate: true // 初始化时立即执行一次
      }
    },
    // 注册复用的详情组件
    components: {
        ArrowRight,
        sanjiaoxinghexing,
        fuwenben,
        hengtu,
        sanhengtufuwenben,
        yeqianfuwenben,
        zuoyiyouer
    },
    methods: {
        // 跳转首页
        index() {
            this.$store.state.components = 'home';
        },
        // 跳转产品列表页
        next() {
            this.$store.state.components = 'product';
        },
        // 获取单个产品详情（同步方案页数据合并逻辑）
        getOneProduct() {
            const productId = this.$store.state.productId;
            newService.getOneProduct(productId).then((res) => {
                // 仅合并已有字段，避免引入多余属性
                this.product = { ...this.product, ...res };
            }).catch((err) => {
                console.error('获取产品详情失败：', err);
            });
        },
        // 组件匹配方法（完全复用方案页逻辑）
        getComponentName(detailType) {
            switch (detailType) {
                case "SAN_JIAO_HE_HEXING":
                    return "sanjiaoxinghexing";
                case "WORD_EDIT":
                    return "fuwenben";
                case "HENG_TU":
                    return "hengtu";
                case "SAN_HENG_TU":
                    return "sanhengtufuwenben";
                case "SPLIT_PAIN":
                    return "yeqianfuwenben";
                case "LEFT1_RIGHT2":
                    return "zuoyiyouer";
                default:
                    return "fuwenben"; // 默认使用富文本组件
            }
        }
    }
};
</script>

<style lang="less" scoped>
// 完全复用方案页样式，保持视觉统一
.product {
  width: 100%;

  // Banner区域样式（与方案页一致）
  .banner {
    background-image: url('@/assets/programme/programme1bg.png');
    background-size: cover;
    background-position: center;
    height: 30rem;
    position: relative;
    margin: 6.4rem auto 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px; // 小屏适配边距

    .banner-container {
      width: 100%;
      max-width: 140rem; // 核心宽度限制
      height: 100%; // 撑满父容器高度
      display: flex;
      align-items: center;
      // 移除左右布局的gap和space-between
      background-size: cover; // 背景图覆盖容器
      background-position: center; // 背景图居中
      background-repeat: no-repeat; // 背景图不重复
      position: relative;
    }

    .title-wrap {
      margin-left: 10rem;
      flex: 1; // 占据剩余空间
      display: flex;
      flex-direction: column;
      gap: 20px; // 标题组内部间距

      .title-row {
        display: flex;
        align-items: center;
        gap: 20px;
        flex-wrap: nowrap; // 强制不换行
      }

      .red-title {
        font-size: 48px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #ed0200;
        margin: 0;
        line-height: 1.2;
      }

      .main-title {
        font-size: 48px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #333;
        margin: 0;
        line-height: 1.2;
      }

      .sub-title {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #333;
        margin: 0;
        line-height: 1.2;
      }

      .synopsis {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #666;
        line-height: 1.8;
        margin: 0;
        max-width: 580px; // 限制简介宽度
      }
    }

    //.banner-image {
    //  width: 580px; // 固定图片宽度
    //  height: auto;
    //  object-fit: contain;
    //  flex-shrink: 0; // 防止图片压缩
    //}
  }

  // 面包屑导航样式
  .linkbanner {
    width: 100%;
    max-width: 120rem;
    height: 4.8rem;
    display: flex;
    align-items: center;
    margin: 2rem auto;
    background: #F8F8F8;
    box-shadow: 0px 1px 0px 0px #E5E5E5;
    padding-left: 2rem;
    font-size: 1.6rem;

    /deep/ .el-link--inner {
      font-size: 1.6rem;
    }

    .breadcrumb-link {
      color: #ED0200;
      font-size: 1.6rem;
      cursor: pointer;
    }

    .breadcrumb-current {
      color: #333;
      font-size: 1.6rem;
      cursor: default;
    }

    i {
      margin: 0 5px;
      font-size: 1.6rem;
      padding-top: 1px;
    }
  }

  // 内容区域样式（与方案页一致）
  .wrap {
    display: block;
    overflow: hidden;
    margin: 0rem auto;
    padding: 0 20px;

    h3 {
      font-size: 2.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 2.8rem;
      margin-bottom: 3.2rem;
    }

    h4 {
      font-size: 1.6rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      margin-bottom: 10.0rem;
      color: #444955;
      line-height: 4.0rem;
    }

    .programmeOne-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 6.0rem auto;

      div {
        width: 18.0rem;
        height: 26.0rem;
        margin: 0 0.5rem 4.0rem;
        background: white;
        box-shadow: 0rem 0.2rem 0.8rem 0rem rgba(0, 0, 0, 0.2);
        border-radius: 0.4rem;
        font-size: 1.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        padding: 2.0rem;
        font-weight: 500;
        color: #333333;
        line-height: 2;

        img {
          width: 2.4rem;
          height: 2.4rem;
          margin-right: 0.5rem;
        }

        h5 {
          margin: 0;
          line-height: 2.0rem;
        }

        span {
          display: flex;
          margin-bottom: 2.0rem;
        }

        em {
          font-style: normal;
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>
